import { Backdrop, CircularProgress } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import WorkIcon from '@mui/icons-material/Work';
import React, { useEffect } from 'react';
import Dimensions from "react-dimensions";
import FlipMove from 'react-flip-move';
import { withRouter } from "react-router-dom";
import { Colors } from "../../constants/Colors";
import { Fonts } from "../../constants/Fonts";
import { decrypt } from '../../crypto/crypto';
import { DrawerComponent } from '../../drawer/DrawerComponent';
import { GetCodeOriginal } from '../../services/api';
import { GetActiveJobs } from '../../services/Jobs';
import { isMobile } from "../../utils/isMobile";
import { Container } from "./styles";
const drawerWidth = 240;
const DRAWER_TEXT = "Bem vindo - " + new Date().getDay() + '/' + new Date().getMonth() + '/' + new Date().getFullYear();
const ticketNotVisibleState = { transform: "translateY(-100%)", opacity: 0.1, transition: '2s' };

const useStyles = makeStyles( ( theme ) => ( {
  backdrop: {
    zIndex: 1,
    color: '#fff',
  },
} ) )

export function Map ( props )
{
  const classes = useStyles();

  const [ dense, setDense ] = React.useState( false );
  const [ open, setOpen ] = React.useState( true );
  const [ openBackground, setOpenBackground ] = React.useState( true );
  const [ JobsList, setJobsList ] = React.useState( [] );

  useEffect( () =>
  {
    Mount()
    console.log( GetCodeOriginal( decrypt( "bKA8NxfPDaY" ) ) )
  }, [] )

  async function Mount ()
  {
    handleToggle()
    await Promise.all( [ GetJobs() ] )
  }

  async function GetJobs ()
  {
    const response = await GetActiveJobs()

    if ( response != undefined )
    {
      if ( response.Sucesso )
      {
        setJobsList( response.Servicos )
      }
      setOpenBackground( false )
      setOpen( false )
    }

  }

  function HandleJoberInfo ( id )
  {
    console.log( id )
    props.history.push( `/JoberProfile:${ id }` );
  }

  function HandleJobInfo ( id )
  {
    props.history.push( `/JobInfo:${ id }` );

  }

  const handleClose = () =>
  {
    setOpen( false );
  }

  const handleToggle = () =>
  {
    setOpen( !open );
  }

  return (
    <></>
  );
}


const styles = {
  WhiteBoldText: {
    fontFamily: Fonts.Primary
    , fontSize: 12
    , color: Colors.White
    , fontWeight: 'bold'
  }
  , BlackBoldText:
  {
    fontFamily: Fonts.Primary
    , fontSize: 15
    , color: Colors.Black
    , fontWeight: 'bold'
  },
  GreenBoldText: {
    fontFamily: Fonts.Primary
    , fontSize: 12
    , color: Colors.White
    , fontWeight: 'bold'
    , borderRadius: 5
    , maxWidth: '50%'
  }
  , BlackNormalText:
  {
    fontFamily: Fonts.Primary
  }
  , WhiteBoldText: { fontFamily: Fonts.Primary, fontSize: 12, color: Colors.White, fontWeight: 'bold' }

  , ListItem: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    borderRadius: 10,
    elevation: 12,
    marginTop: '2%',
    backgroundColor: Colors.Primary,
    width: isMobile ? '85vw' : '75vw',
    marginBottom: isMobile ? '5%' : '0',
  }
}

const DimensionedMap = withRouter( Dimensions()( Map ) );

const App = () => (
  <Container>
    <DimensionedMap />
  </Container>
);

export default App;